import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Component } from 'react';
var css = {
  "messageBox": "rui-vzp8j",
  "message": "rui-ZIqlu"
};
import classNames from 'classnames';
var ToastMessage = /*#__PURE__*/function (_Component) {
  _inherits(ToastMessage, _Component);
  var _super = _createSuper(ToastMessage);
  function ToastMessage() {
    _classCallCheck(this, ToastMessage);
    return _super.apply(this, arguments);
  }
  _createClass(ToastMessage, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this = this;
      var _this$props = this.props,
        onExpired = _this$props.onExpired,
        expiration = _this$props.expiration;
      this.timer = setTimeout(function () {
        delete _this.timer;
        onExpired === null || onExpired === void 0 ? void 0 : onExpired();
      }, expiration);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        children = _this$props2.children,
        position = _this$props2.position,
        className = _this$props2.className;
      return /*#__PURE__*/React.createElement("div", {
        className: classNames(className, css.messageBox),
        style: {
          position: position
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: css.message
      }, children));
    }
  }]);
  return ToastMessage;
}(Component);
ToastMessage.defaultProps = {
  expiration: 5000,
  onExpired: function onExpired() {},
  position: 'fixed',
  className: ''
};
export default ToastMessage;